import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { VideoSection } from './components/VideoSection';
import { Benefits } from './components/Benefits';
import { TemplatesSection } from './components/TemplatesSection';
import { Gallery } from './components/Gallery';
import { GuideContents } from './components/GuideContents';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Deco Emprende | Falso Vitral Deco';
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '989000920158429');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=989000920158429&ev=PageView&noscript=1" />';
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-deco-bg font-sans selection:bg-deco-terra selection:text-white" data-id="element-0" data-mp="stc864jdl0nw">
      <TopBar data-id="element-1" data-mp="356s95xbri9l" />
      <OfferBar data-id="element-2" data-mp="34nb3rfi0xwm" />
      <main className="overflow-hidden" data-id="element-3" data-mp="38b5stwojqcx">
        <Hero data-id="element-4" data-mp="3udkmfuysas9v" />
        <VideoSection data-id="element-5" data-mp="3ubzso7kandd2" />
        <Benefits data-id="element-6" data-mp="3ucjehzd2elwd" />
        <TemplatesSection data-id="element-7" data-mp="3uf5g7id9y76o" />
        <Gallery data-id="element-8" data-mp="d57fv4288kjl" />
        <GuideContents data-id="element-9" data-mp="d3mmhhrnf7nb" />
        <Bonuses data-id="element-10" data-mp="d3wch5cp1et0" />
        <Testimonials data-id="element-11" data-mp="d2bj3j2481wq" />
        <PurchaseSection data-id="element-12" data-mp="85ukfuxai55e" />
        <FAQ data-id="element-13" data-mp="86mh792mi8x9" />
      </main>
      <Footer data-id="element-14" data-mp="86cmj86mvdl8" />
      <SocialProofPopup data-id="element-15" data-mp="83qgxe3az85n" />
    </div>;
}